
import { Component, Prop, Vue } from 'vue-property-decorator';
import type { QoutAllRow } from '../../model';

@Component
export default class QoutAllTable extends Vue {
  @Prop({ required: true })
  data!: QoutAllRow[];

  get damsHeaders(): string[] {
    const firstRow = (this.data as QoutAllRow[] | undefined)?.[0];
    if (firstRow) {
      return firstRow.dams.map((dam) => dam.label);
    }
    return [];
  }
}
